<template>
  <div class="root-view">
    <div class="tips">系统已经根据您的做卷情况智能推送相应难度的题目，如果还需要进行难度调整，可在此功能进行设置！</div>
    <div v-for="(item, index) in difficultyData" :key="index">
      <CustomSlider :subjectId="item.subject_id"
                    :subjectName="item.subject_name"
                    :diffcult="item.subject_difficulty_offset"
                    @changeDiffculty="changeDiffculty"/>
    </div>
  </div>
</template>

<script>

import CustomSlider from '@/views/components/CustomSlider.vue'

export default {
  data () {
    return {
      difficultyData: []
    }
  },
  components: {
    CustomSlider
  },
  mounted () {
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.$http({
      url: '/api/v1/user/get_difficulty',
      method: 'get',
      params: { grade_id: userInfo.edu_grade_id}
    }).then(res => {
      this.difficultyData = res.data

    })
  },
  methods: {
    changeDiffculty (val) {
      this.$http({
        url: '/api/v1/user/difficulty',
        method: 'post',
        data: val
      }).then(res => {
        // console.log("789",val)
        let subjectName = this.difficultyData.find(item => item.subject_id == val.subject_id).subject_name
        this.$message.success(`${subjectName}难度调整成功！`)
      })
    },

  }
}
</script>

<style lang="scss" scoped>

.root-view{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:75rem;
  padding-bottom: 100px;
}

.tips{
  width:752rem;
  color: #666;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px; /* 150% */
}


</style>